// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PictureTwoToneSvg from "@fishx/icons-svg/es/asn/PictureTwoTone";
import FishxIcon from '../components/FishxIcon';

var PictureTwoTone = function PictureTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PictureTwoToneSvg
  }));
};

PictureTwoTone.displayName = 'PictureTwoTone';
export default React.forwardRef(PictureTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PictureTwoTone.js
// module id = 3785
// module chunks = 0